import { Component } from "react";
import MenuItem from "@mui/material/MenuItem";
import { Button } from "@mui/material";
import Icon from "@mui/material/Icon/Icon";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import { NO_VALUE } from "../../../constants";
import { clone, guid } from "../../../utils";
import CustomizedSelect from "../../Input/CustomizedSelect";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";

class FormSelectField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    getSortedAnswers() {
        const answers = this.props.answers || [];
        return answers.slice().sort((a1, a2) => {
            if (a1.sequence < a2.sequence) return -1;
            if (a1.sequence > a2.sequence) return 1;
            return 0;
        });
    }

    handleChange(e) {
        let response = clone(this.props.question);

        if (this.props.multiple) {
            response.response_answers.forEach((ra) => (ra.deleted = true));
            e.target.value.forEach((selectedId) => {
                if (selectedId == NO_VALUE) return;

                let ra = response.response_answers.find((ra) => ra.answer_id == selectedId);

                if (ra) ra.deleted = false;
                else {
                    let currentResponseAnswer = {
                        answer: "True",
                        answer_id: selectedId,
                        column_id: false,
                        comment: "",
                        comment_field: "",
                        id: null,
                        guid: guid(),
                        response_id: response.id,
                        value_choice: "",
                        deleted: false,
                    };

                    response.response_answers.push(currentResponseAnswer);
                }
            });
        } else if (this.props.ratingScale) {
            response = e.target.value;
        } else {
            response.response_answers.forEach((ra) => (ra.deleted = true));

            if (e.target.value !== NO_VALUE) {
                let currentResponseAnswer = response.response_answers.find((ra) => ra.answer_id == e.target.value);

                if (!currentResponseAnswer) {
                    currentResponseAnswer = {
                        answer: "True",
                        answer_id: e.target.value,
                        column_id: false,
                        comment: "",
                        comment_field: "",
                        id: null,
                        guid: guid(),
                        response_id: response.id,
                        value_choice: "",
                        deleted: false,
                    };

                    response.response_answers.push(currentResponseAnswer);
                }

                currentResponseAnswer.deleted = false;
            }
        }

        const sortedAnswers = this.getSortedAnswers();
        const shortAnswers = sortedAnswers.length <= 3;
        if (shortAnswers && typeof this.props.save === "function") {
            this.props.save();
        }

        this.props.responseValueChange(response);
    }

    handleMultipleCheckboxChange(e) {
        let value = e.target.value;
        let checked = e.target.checked;
        let response = clone(this.props.question);
        const existing = response.response_answers.find(x => x.answer_id == value);
        if (existing) {
            existing.deleted = !checked;       
        } else if (checked) {
            let currentResponseAnswer = {
                answer: "True",
                answer_id: value,
                column_id: false,
                comment: "",
                comment_field: "",
                id: null,
                guid: guid(),
                response_id: response.id,
                value_choice: "",
                deleted: false,
            }

            response.response_answers.push(currentResponseAnswer);
        }

        const sortedAnswers = this.getSortedAnswers();
        const shortAnswers = sortedAnswers.length <= 3;
        if (shortAnswers && typeof this.props.save === "function") {
            this.props.save();
        }

        this.props.responseValueChange(response);
    }

    openSelect() {
        this.setState({ open: true });
    }

    closeSelect() {
        if (typeof this.props.save === "function") {
            this.props.save();
        }
        this.setState({ open: false });
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let values = [];
        let value = "";

        if (this.props.multiple) {
            values = this.props.question.response_answers.filter((ra) => !ra.deleted);
            value = values.map((ra) => ra.answer_id);
        } else if (this.props.ratingScale) {
            let currentColumnHeading;

            if (this.props.question)
                currentColumnHeading = this.props.answers.find((chi) => chi.id == this.props.question.column_id);

            value = "";
            if (currentColumnHeading) value = currentColumnHeading.id;
        } else {
            values = this.props.question.response_answers.filter((ra) => !ra.deleted);
            if (values.length > 0) value = values[0].answer_id ?? "";
            else value = "";
        }

        const sortedAnswers = this.getSortedAnswers();
        const shortAnswers = sortedAnswers.length <= 3;

        let rows = [];

        if (shortAnswers) {
            for (let i = 0; i < sortedAnswers.length; i++) {
                let currentRow = sortedAnswers[i];

                if (this.props.multiple) {
                    rows.push(
                        <FormControlLabel
                            value={currentRow.id}
                            control={<Checkbox />}
                            onChange={this.handleMultipleCheckboxChange.bind(this)}
                            label={this.props.ratingScale ? currentRow.title : currentRow.answer}
                            disabled={this.props.inputProperties.disabled}
                        />
                    );
                } else {
                    rows.push(
                        <FormControlLabel
                            value={currentRow.id}
                            control={<Radio />}
                            label={this.props.ratingScale ? currentRow.title : currentRow.answer}
                            disabled={this.props.inputProperties.disabled}
                        />
                    );
                }
            }
        } else {
            rows.push(
                <MenuItem key={NO_VALUE} value={NO_VALUE}>
                    {this.props.multiple ? (
                        <Button
                            className="col-lg-12 col-md-12 col-sm-12 col-12 without-padding"
                            onClick={this.closeSelect.bind(this)}
                        >
                            <Icon className="green-icon">check</Icon>
                        </Button>
                    ) : (
                        ""
                    )}
                </MenuItem>
            );
            for (let i = 0; i < sortedAnswers.length; i++) {
                let currentRow = sortedAnswers[i];
                rows.push(
                    <MenuItem
                        key={i}
                        value={currentRow.id}
                        disabled={
                            this.props.metaQuestion.required_type === "at most" &&
                            this.props.metaQuestion.req_ans &&
                            this.props.multiple &&
                            values.length >= this.props.metaQuestion.req_ans &&
                            !values.some((x) => x.answer_id === currentRow.id)
                        }
                    >
                        {this.props.ratingScale ? currentRow.title : currentRow.answer}
                    </MenuItem>
                );
            }
        }

        return (
            <div className=" col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                {shortAnswers ? (
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="radio-buttons-group-label"
                            defaultValue={sortedAnswers.length > 0 ? sortedAnswers[0].id : ""}
                            name="radio-buttons-group"
                            onChange={this.handleChange.bind(this)}
                            value={value}
                        >
                            {rows}
                        </RadioGroup>
                    </FormControl>
                ) : (
                    <CustomizedSelect
                        {...this.props.inputProperties}
                        multiple={this.props.multiple}
                        className={
                            this.props.inputProperties.className +
                            " full_size " +
                            (this.props.inputProperties.disabled ? "light-disabled" : "") +
                            "control-margin-top"
                        }
                        onChange={this.handleChange.bind(this)}
                        onOpen={this.openSelect.bind(this)}
                        onClose={this.closeSelect.bind(this)}
                        open={this.state.open}
                        value={value}
                    >
                        {rows}
                    </CustomizedSelect>
                )}
            </div>
        );
    }
}

export default FormSelectField;
